import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { PlusIcon, TrashIcon, PencilIcon } from '@heroicons/react/24/outline'

function ServicesForm({ services, onServicesChange }) {
  const [showForm, setShowForm] = useState(false)
  const [editing, setEditing] = useState(null)
  const [formData, setFormData] = useState({ title: '', desc: '', icon: '💼' })

  const icons = ['💼', '📞', '📧', '📍', '⚙️', '🧠', '🚀', '📚']

  const addService = () => {
    if (!formData.title.trim()) return
    const item = {
      id: Date.now().toString(),
      title: formData.title.trim(),
      desc: formData.desc.trim(),
      icon: formData.icon
    }
    onServicesChange([...(services || []), item])
    reset()
  }

  const saveEdit = () => {
    if (!formData.title.trim()) return
    const updated = services.map(s => s.id === editing.id ? { ...s, ...formData, title: formData.title.trim(), desc: formData.desc.trim() } : s)
    onServicesChange(updated)
    reset()
  }

  const removeService = (id) => {
    if (window.confirm('¿Eliminar este servicio?')) {
      onServicesChange(services.filter(s => s.id !== id))
    }
  }

  const startEdit = (svc) => {
    setEditing(svc)
    setFormData({ title: svc.title, desc: svc.desc || '', icon: svc.icon || '💼' })
    setShowForm(true)
  }

  const reset = () => {
    setFormData({ title: '', desc: '', icon: '💼' })
    setEditing(null)
    setShowForm(false)
  }

  return (
    <div className="space-y-6">
      {services && services.length > 0 && (
        <div className="space-y-4">
          <h3 className="text-lg font-medium text-gray-900">Tus Servicios ({services.length})</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((svc) => (
              <div key={svc.id} className="bg-white border rounded-lg p-4">
                <div className="text-3xl">{svc.icon || '💼'}</div>
                <h4 className="font-semibold text-gray-900 mt-2">{svc.title}</h4>
                {svc.desc && <p className="text-sm text-gray-600 mt-1">{svc.desc}</p>}
                <div className="flex justify-between items-center mt-3 pt-3 border-t">
                  <button onClick={() => startEdit(svc)} className="flex items-center text-blue-600 hover:text-blue-800 text-sm">
                    <PencilIcon className="w-4 h-4 mr-1" /> Editar
                  </button>
                  <button onClick={() => removeService(svc.id)} className="flex items-center text-red-600 hover:text-red-800 text-sm">
                    <TrashIcon className="w-4 h-4 mr-1" /> Eliminar
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="border-t pt-6">
        {!showForm ? (
          <button onClick={() => setShowForm(true)} className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
            <PlusIcon className="w-4 h-4 mr-2" /> Agregar Servicio
          </button>
        ) : (
          <div className="bg-gray-50 rounded-lg p-6">
            <h4 className="text-lg font-medium text-gray-900 mb-4">{editing ? 'Editar Servicio' : 'Nuevo Servicio'}</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Título *</label>
                <input type="text" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Ej: Consultoría" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Icono</label>
                <select value={formData.icon} onChange={(e) => setFormData({ ...formData, icon: e.target.value })} className="form-input">
                  {icons.map((ic) => (<option key={ic} value={ic}>{ic}</option>))}
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">Descripción</label>
                <textarea value={formData.desc} onChange={(e) => setFormData({ ...formData, desc: e.target.value })} rows={3} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Describe el servicio..." />
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6">
              <button type="button" onClick={reset} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">Cancelar</button>
              <button type="button" onClick={editing ? saveEdit : addService} disabled={!formData.title.trim()} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-300">{editing ? 'Guardar Cambios' : 'Agregar Servicio'}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

ServicesForm.propTypes = {
  services: PropTypes.array.isRequired,
  onServicesChange: PropTypes.func.isRequired,
}

export default ServicesForm
